import UnderstandSectionEntity from "@domains/aggregates/Reports/common/UnderstandingSection";
import UnderstandSectionSubEntity from "@domains/aggregates/Reports/common/UnderstandingSectionSubEntity";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class UnderstandSectionRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getUnderstandingSectionData(reportName, type) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.understandingSectUrl);
        url.searchParams.append("reportName", reportName);
        if (type)
            url.searchParams.append("type", type);
        const apiResult = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        if (apiResult) {
            const reportSummary = apiResult.data.reportSummary.map((summaryParam) => {
                return new UnderstandSectionSubEntity(summaryParam);
            });
            const reportDetails = apiResult.data.reportDetails.map((summaryParam) => {
                return new UnderstandSectionSubEntity(summaryParam);
            });
            const understandingData = reportDetails.concat(reportSummary);
            return new UnderstandSectionEntity(understandingData);
        }
        else {
            return new UnderstandSectionEntity([]);
        }
    }
}
export default UnderstandSectionRepository;
